import AudioAnalyserBars from "../Controllers/AudioAnalyser/AudioAnalyserBars";
import { deviceSettings, getUsersPreferedSettings } from "../engine/data/globalState";
import { ParticipantMode } from "../Navbar/Navbar";
import { enumerateDevices, getUserMedia, requestMediaPermissions } from "../engine/helpers/userMediaHelper";
import VolumeAnalyser from "../Controllers/AudioAnalyser/VolumeAnalyser";

export default class InitDeviceCheck {
  /**
   * @param {Model} model
   * @param container
   * @param onSave
   */
  constructor({ model, container, onSave }) {
    this.model = model;
    this.container = $(container);
    this.onSave = onSave;

    this.blockCounter = 0;

    this.isRequestPermissionOnly = false

    this.volumeAnalyser = null

    this.modal = $("#welcomeCheckModal");
    this.imageWrapper = this.container.find(".welcome-check-avatar-image");
    this.video = this.container.find(".welcome-check-webcam");
    this.saveButton = this.container.find("#save-welcome-check");
    this.backButton = this.container.find("#goback-welcome-check");
    this.proceedWithMediaBtn = this.container.find("#proceed-with-media-btn");
    this.proceedAsSpectatorBtn = this.container.find("#proceed-as-spectator-btn");
    this.cameraIcon = this.container.find(".welcome-check-camera");
    this.micIcon = this.container.find(".welcome-check-microphone");
    this.micSelect = this.container.find('#welcome-check-micSelect')
    this.speakerSelect = this.container.find('#welcome-check-speakerSelect')
    this.camSelect = this.container.find('#welcome-check-camSelect')
    this.requestPermissionsButton = $("#permission-denied-check");
    this.welcomeInvokeSelfCheckButton = $("#welcome-self-check");
    this.welcomeInvokeSelfCheckButton.hide();
    this.useAllFeatures = this.container.find(".confirm-body");
    this.container.find(".welcome-check-modal__location").text(this.model.sceneData.name)

    this.init();
  }

  init() {
    if (this.model.isEmbed === "0") {
      return;
    }
    this.loadInvertCameraState();
    this.addEventListeners();

    if (this.model.autoSeat) {
      this.modal.removeClass("is-active");
      this.onSave = () => {
        $('.video-indicator').each(function (index, el) {
          el.srcObject = this.stream; //TODO listen when loaded
        });
        this.model.onTakeFirstEmptySeat();
      }
    }
    this.modal.addClass("is-active");
  }

  async showMediaRequestModal({ onSave } = {}) {
    this.isRequestPermissionOnly = true

    if (onSave) {
      this.onSave = onSave
    }

    this.modal.addClass("is-active")
    this.modal.addClass('welcome-check-modal--request-permission-only')

    $('.welcome-check-modal__content--step-1').addClass('is-hidden')
    $('.welcome-check-modal__content--step-2').removeClass('is-hidden')

    await this.requestPermissions();
    await this.populateDeviceDropdowns();
  }

  loadInvertCameraState() {
    const savedState = JSON.parse(localStorage.getItem('user_invert_camera_'));
    const isInverted = savedState && savedState.state;
    $('#welcomeCheckInvertCamera').prop('checked', isInverted);

    if (isInverted) {
      this.video.addClass('invert');
    } else {
      this.video.removeClass('invert');
    }
    deviceSettings.userCameraInverted = isInverted
  }

  addEventListeners() {
    $('#welcomeCheckInvertCamera').on('change', (e) => {
      const state = $(e.target).prop('checked');
      localStorage.setItem('user_invert_camera_', JSON.stringify({ state }));
      deviceSettings.userCameraInverted = state;

      if (state) {
        this.video.addClass('invert');
      } else {
        this.video.removeClass('invert');
      }
    });

    this.saveButton.on("click", () => {
      this.model.spectatorMode = false;

      const microphoneDevice = this.micSelect.val()
      const cameraDevice = this.camSelect.val()
      const soundDevice = this.speakerSelect.val()

      microphoneDevice && localStorage.setItem('microphoneDevice', microphoneDevice);
      cameraDevice && localStorage.setItem('cameraDevice', cameraDevice);
      soundDevice && localStorage.setItem('soundDevice', soundDevice);

      this.onSave && this.onSave();
      this.close();

      ParticipantMode.hideButton()
    });

    this.proceedAsSpectatorBtn.on("click", () => {
      this.model.spectatorMode = true;
      this.onSave && this.onSave();
      this.close();
    });

    this.proceedWithMediaBtn.on('click', () => {
      $('.welcome-check-modal__content--step-1').addClass('is-hidden')
      $('.welcome-check-modal__content--step-2').removeClass('is-hidden')

      this.populateDeviceDropdowns();
      this.requestPermissions();
    })

    this.backButton.on('click', () => {
      if (this.isRequestPermissionOnly) {
        this.close()
      } else {
        $('.welcome-check-modal__content--step-1').removeClass('is-hidden')
        $('.welcome-check-modal__content--step-2').addClass('is-hidden')
      }
    })

    this.requestPermissionsButton.on("click", () => {
      $(".permissionDenied-modal").removeClass("is-active");
      if (this.blockCounter < 2) {
        this.requestPermissions();
        this.welcomeInvokeSelfCheckButton.show();
      } else {
        this.model.initDeviceCheck = true;
      }
    });

    this.welcomeInvokeSelfCheckButton.on("click", () => {
      this.close();
      $("#invokeSelfTest").trigger("click");
    });

    this.welcomeInvokeSelfCheckButton.hide();
    this.cameraIcon.hide();
    this.micIcon.hide();
    this.useAllFeatures.hide();
  }

  populateDeviceDropdowns() {
    enumerateDevices(this.model).then(devices => {
      const audioInputs = devices.filter(device => device.kind === 'audioinput');
      const audioOutputs = devices.filter(device => device.kind === 'audiooutput');
      const videoInputs = devices.filter(device => device.kind === 'videoinput');

      this.populateSelect(this.micSelect, audioInputs);
      this.populateSelect(this.speakerSelect, audioOutputs);
      this.populateSelect(this.camSelect, videoInputs);

      this.setActiveDeviceSelections(audioInputs, videoInputs);

      this.micSelect.on('change', () => this.handleMicSelection());
      this.speakerSelect.on('change', () => this.handleSpeakerSelection());
      this.camSelect.on('change', () => this.handleCamSelection());

      this.micSelect.removeAttr('disabled').parent().removeClass('welcome-check-modal__devices__device--disabled')
      this.speakerSelect.removeAttr('disabled').parent().removeClass('welcome-check-modal__devices__device--disabled')
      this.camSelect.removeAttr('disabled').parent().removeClass('welcome-check-modal__devices__device--disabled')

      this.saveButton.removeAttr('disabled')
    }).catch(() => {
      this.model.alert('error', `Cannot access multimedia devices.`);
      this.onFailedPermission();
    });
  }

  populateSelect(selectElement, devices) {
    selectElement.empty();
    devices.forEach(device => {
      selectElement.append(new Option(device.label, device.deviceId));
    });
  }

  setActiveDeviceSelections(audioInputs, videoInputs) {
    const activeAudioTrack = this.stream?.getAudioTracks()[0];
    const activeVideoTrack = this.stream?.getVideoTracks()[0];

    if (activeAudioTrack) {
      const activeAudioInput = audioInputs.find(device => device.deviceId === activeAudioTrack.getSettings().deviceId);
      if (activeAudioInput) {
        this.container.find('#welcome-check-micSelect').val(activeAudioInput.deviceId);
        deviceSettings.microphone = { name: activeAudioInput.label, value: activeAudioInput.deviceId };
      }
    }

    if (activeVideoTrack) {
      const activeVideoInput = videoInputs.find(device => device.deviceId === activeVideoTrack.getSettings().deviceId);
      if (activeVideoInput) {
        this.container.find('#welcome-check-camSelect').val(activeVideoInput.deviceId);
        deviceSettings.camera = { name: activeVideoInput.label, value: activeVideoInput.deviceId };
      }
    }
  }

  handleMicSelection() {
    const selectedMicrophone = this.container.find('#welcome-check-micSelect option:selected').val();
    deviceSettings.microphone = {
      name: this.container.find('#welcome-check-micSelect option:selected').text(),
      value: selectedMicrophone,
    };
    console.log('Microphone selected:', selectedMicrophone);
    this.startMicrophoneStream(selectedMicrophone);
  }

  startMicrophoneStream(deviceId) {
    getUserMedia({ audio: { deviceId: { exact: deviceId } } })
      .then(stream => {
        this.stream = stream;

        this.removeMicTestHandler()
        this.setMicTestHandler(stream);
      })
      .catch(error => console.log('Failed to start microphone stream:', error));
  }

  removeMicTestHandler() {
    if (this.volumeAnalyser) {
      this.model.removeAudioAnalyzer(this.volumeAnalyser)
      this.volumeAnalyser.destroy()
      this.volumeAnalyser = null
    }
  }

  setMicTestHandler(stream) {
    if (!this.volumeAnalyser) {

      const speakingIndicatorContainer = this.container.find('.device-setting-micTest');
      const speakingIndicator = this.container.find('.speaking-indicator');
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
      this.volumeAnalyser = new VolumeAnalyser();
      this.volumeAnalyser.setOnSpeakingChanged((speaking) => {
        speakingIndicator.toggleClass('speaking-indicator--active', speaking)
        speakingIndicatorContainer.toggleClass('speaking-outline', speaking)
      })

      this.model.registerAudioAnalyzer(this.volumeAnalyser);
    }

    this.volumeAnalyser
      .setAudioContext(this.audioContext)
      .setStream(stream)
      // width of avatar, width of the indicator
      .setScaleRangeFromPixels(180, 200)
      .setEnabled(true)
  }

  handleSpeakerSelection() {
    const selectedSpeaker = this.container.find('#welcome-check-speakerSelect option:selected').val();
    deviceSettings.speaker = {
      name: this.container.find('#welcome-check-speakerSelect option:selected').text(),
      value: selectedSpeaker,
    };
    console.log('Speaker selected:', selectedSpeaker);
  }

  handleCamSelection() {
    const selectedCameraId = this.container.find('#welcome-check-camSelect option:selected').val();
    deviceSettings.camera = {
      name: this.container.find('#welcome-check-camSelect option:selected').text(),
      value: selectedCameraId,
    };
    this.startCameraStream(selectedCameraId);
  }

  async requestPermissions() {
    try {
      let stream = await getUserMedia({ audio: true, video: true }, this.model);

      try {
        const devices = await enumerateDevices(this.model)

        const audioInputs = devices.filter(device => device.kind === 'audioinput');
        const audioOutputs = devices.filter(device => device.kind === 'audiooutput');
        const videoInputs = devices.filter(device => device.kind === 'videoinput');

        const microphoneDevice = localStorage.getItem('microphoneDevice')
        const cameraDevice = localStorage.getItem('cameraDevice')
        const soundDevice = localStorage.getItem('soundDevice')

        const audioInput = audioInputs.find(device => device.deviceId === microphoneDevice) ?? audioInputs[0] ?? null
        const videoInput = videoInputs.find(device => device.deviceId === cameraDevice) ?? videoInputs[0] ?? null
        const audioOutput = audioOutputs.find(device => device.deviceId === soundDevice) ?? audioOutputs[0] ?? null

        const audioConstraints = audioInput ? { deviceId: { exact: audioInput.deviceId } } : true
        const videoConstraints = videoInput ? { deviceId: { exact: videoInput.deviceId } } : true

        stream = await getUserMedia({ audio: audioConstraints, video: videoConstraints }, this.model);
      } catch (error) {
        console.error('Error when getting stream for designated devices, keep using default devices', error)
      }

      this.onPermissionsGranted(stream);
    } catch (error) {
      this.onPermissionsDenied(error);
    }
  }

  onPermissionsGranted(stream) {
    this.stream = stream;
    this.video[0].srcObject = stream;
    this.populateDeviceDropdowns();
    this.imageWrapper.hide();
    this.removeMicTestHandler()
    this.setMicTestHandler(stream);
    this.saveButton.removeClass('disabled');
    this.cameraIcon.show();
    this.micIcon.show();
    this.welcomeInvokeSelfCheckButton.hide();
    this.useAllFeatures.hide();
    this.micIcon.css('background', '');
    this.cameraIcon.css('background', '');
    if (this.model.autoSeat) {
      this.model.initDeviceCheck = true;
      this.close();
    }
  }

  onPermissionsDenied(error) {
    this.useAllFeatures.show();
    this.model.alert('error', `You need to enable permission for camera and microphone`);
    this.saveButton.removeClass('disabled');
    this.onFailedPermission();
    console.log('Permission request failed:', error);
    this.blockCounter++;
  }

  startCameraStream(deviceId) {
    getUserMedia({ video: { deviceId: { exact: deviceId } } }, this.model)
      .then(stream => {
        this.video[0].srcObject = stream;
      })
      .catch(error => {
        console.log('Failed to start camera stream:', error);
        this.onFailedPermission();
      });
  }

  stopStream() {
    if (this.stream) {
      this.model.killStream(this.stream);
    }
  }

  onFailedPermission() {
    $(".permissionDenied-modal").addClass("is-active");

    this.saveButton.attr('disabled', 'disabled');
    this.camSelect.attr('disalbed', 'disabled').parent().addClass('welcome-check-modal__devices__device--disabled')
    this.speakerSelect.attr('disalbed', 'disabled').parent().addClass('welcome-check-modal__devices__device--disabled')
    this.micSelect.attr('disalbed', 'disabled').parent().addClass('welcome-check-modal__devices__device--disabled')
  }

  close() {
    this.model.initDeviceCheck = true;
    const savedState = JSON.parse(localStorage.getItem('user_invert_camera_'));
    const isInverted = savedState && savedState.state;
    this.model.view.deviceSettingsMenu.selected.userCameraInverted = isInverted;
    this.removeMicTestHandler();
    !this.model.autoSeat && this.stopStream(); // Stop all active tracks in the stream
    this.modal.removeClass("is-active");
    if (!this.isRequestPermissionOnly) {
      this.model.onUserClosedInitDeviceCheckModal();
    }
  }
}
